import { EpimsBaseEntityDto } from './epim-base.dto';
export class LossOfUseItemsDto extends EpimsBaseEntityDto {
  LossOfUseItemDesc: string;
  Rate: number;
  Remarks: string;
  UomId: string;
  UomName: string;
  SubscriptionUserId: string;  
  Version: number;
}
